// extracted by mini-css-extract-plugin
export default {"bigImg":"styles_bigImg__bLv73"};